import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutomaticScriptTreeService {
  private activeNode = new BehaviorSubject<string | null>(null);

  setActiveNode(node: any): void {
    this.activeNode.next(node);
  }

  getActiveNode(): Observable<string | null> {
    return this.activeNode.asObservable();
  }
}
